import axios from 'axios';
import handleApiError from './handleApiError';
import { Guest } from '@synergy/sf-commons';

export const verifyPhoneNumber = async (phoneNumber: string, onError?: Guest<unknown>) => {
  try {
    const { data } = await axios.post('/api/phoneVerification', {
      phone: phoneNumber,
    });
    return data?.response;
  } catch (error: any) {
    onError?.receive({
      message: error?.response?.data,
    });
    if (!onError) {
      handleApiError(error);
    } else {
      throw new Error('Ошибка верификации');
    }
  }
};

export const verifyCode = async (code: string) => {
  try {
    return await axios.get('/api/phoneVerification', {
      params: {
        code,
      },
    });
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
